export class FailResponseObject {
  errors: {
    code: string;
    description: string | null;
    error: any;
    keyword: string;
    message: string;
  }[];

  constructor(init?: Partial<FailResponseObject>) {
    Object.assign(this, init);
  }
}

export class SuccessResponseObject<T = any> {
  data: T[];
  page: {
  size: number; // pageSize
  number: number; // pageNumber
  total: number; // totalCount, total of items/records
  };
  sort: any;

  constructor(init?: Partial<SuccessResponseObject<T>>) {
    Object.assign(this, init);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/shared/response-object.ts